import { render, staticRenderFns } from "./Howpinposworks.vue?vue&type=template&id=703b5808&scoped=true"
import script from "./Howpinposworks.vue?vue&type=script&lang=js"
export * from "./Howpinposworks.vue?vue&type=script&lang=js"
import style0 from "./Howpinposworks.vue?vue&type=style&index=0&id=703b5808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703b5808",
  null
  
)

export default component.exports